import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* BrowserRouter: I used this router but many users advice that to use the HashRouter instead. */}
        <HashRouter>
            <App />
        </HashRouter>
    </React.StrictMode>
);